<template>
  <div class="standardImage"
    :class="{hasImg: item.value}">
    <div class="imgFrame" :style="imgStyle">
      <img v-if="item.value !== null" :src="item.value" alt="" />
      <div v-if="item.value !== null" class="dimmer" :style="{backgroundColor: item.dimmer}"></div>
    </div>
    <div class="editImage">
      <label class="uploadImg">
        <input type="file" @change="uploadImage(item, $event)">
      </label>
      <div v-if="item.value" class="colorPreset">
        <button v-if="item.value" type="button" class="btnDimmer" @click="colorPicker($event, item)">
          <i class="bg"></i>
          <i :style="{backgroundColor: currentColor}"></i>
        </button>
        <sketch-picker style="display: none"
          :value="currentColor"
          @input="settingColor" />
      </div>
      <div class="enlargeImg">
        <input type="checkbox" :id="`enlarge_img_${id}_${item.columnId}`" :checked="item.enlarge" @change="enlargeImage(item, $event)">
        <label :for="`enlarge_img_${id}_${item.columnId}`"></label>
      </div>
      <button v-if="item.value" type="button" class="btnDel" @click="delImage($event, item)"></button>
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import sketch from 'vue-color/src/components/Sketch.vue'

export default {
  name: 'ImageModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  computed: {
    dimmer () {
      return this.item.value !== null && this.item.dimmer
    },
    imgStyle () {
      const detail = this.item.detail || null
      const border = detail && detail.border && detail.border.active ? detail.border : null
      const background = detail && detail.background && detail.background.active ? detail.background : null
      const bgImg = background && background.value ? `url(${background.value}) ${background.position} / ${background.size} ${background.repeat}` : ''
      const radius = detail && detail.radius && detail.radius.active ? detail.radius : null
      const borderRadius = radius ? `${radius.tl}px ${radius.tr}px ${radius.br}px ${radius.bl}px` : null
      return {
        ...border && {
          border: `1px ${border.style} ${border.color}`
        },
        'border-radius': borderRadius,
        ...background && {
          background: `${background.color} ${bgImg}`
        }
      }
    }
  },
  components: {
    'sketch-picker': sketch
  },
  data () {
    return {
      transparent: 'rgba(255, 255, 255, 0)',
      currentColor: ''
    }
  },
  methods: {
    uploadImage (item, e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          item.value = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delImage (e, item) {
      e.stopPropagation()
      if (window.confirm(this.locale.confirm_delete_image)) {
        item.value = null
      }
    },
    enlargeImage (item, e) {
      const isEnlarge = e.target.checked
      this.item.enlarge = isEnlarge
    },
    settingColor (c) {
      const rgba = `rgba(${c.rgba.r}, ${c.rgba.g}, ${c.rgba.b}, ${c.rgba.a})`
      this.currentColor = rgba
      this.item.dimmer = rgba
    },
    colorPicker: function (e, item) {
      this.currentColor = item.dimmer || this.transparent
      document.querySelectorAll('.vc-sketch').forEach(x => {
        x.style.display = 'none'
      })
      e.currentTarget.closest('.colorPreset').classList.add('active')
      e.currentTarget.nextSibling.style.display = 'block'
      document.addEventListener('click', this.hideColorPicker)
    },
    hideColorPicker: function (e) {
      if (e.target.closest('.colorPreset') === null) {
        document.querySelectorAll('.colorPreset').forEach(x => {
          x.classList.remove('active')
        })
        document.querySelectorAll('.vc-sketch').forEach(x => {
          x.style.display = 'none'
        })
        document.removeEventListener('click', this.hideColorPicker)
      }
    }
  }
}
</script>
